import React, { useContext, useState, useRef, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { AuthenticationContext } from 'app/Contexts/AuthenticationProvider'
import { Steps } from './Steps'
import { ShowData } from './ShowData'
import { HeaderContext } from 'app/Contexts/HeaderProvider'
import { CompleteRegistration } from 'app/components/shared/CompleteRegistration'
import { Modal } from 'app/components/ui/Modal'
import { InputHolderDocument } from './Steps/InputHolderDocument'
import { RegistrationThanks } from './RegistrationThanks'
import { Container } from 'app/components/ui/Container'
import { routes } from 'app/routes'

type LocationState = {
  showHolderDocumentUploadModal?: boolean
}

export const Profile: React.FC = () => {
  const [showRegistrationThanks, setShowRegistrationThanks] = useState(false)
  const step2Ref = useRef<HTMLDivElement>(null)
  const { push, location } = useHistory<LocationState>()
  const authCtx = useContext(AuthenticationContext)
  const headerCtx = useContext(HeaderContext)

  const supplier = authCtx?.actor?.supplier

  if (!supplier) return null

  const showSteps = supplier?.status === 'ready_for_registry'

  const [showHolderDocumentModal, setShowHolderDocumentModal] = useState(
    location.state?.showHolderDocumentUploadModal || false
  )

  const headerTitle = 'Area fornitori Marketing'
  const headerSubTitle = 'Una foto, una firma e ci siamo!'

  const headerRegistrationCompleteSubTitle = 'Una foto, una firma e ci siamo!'

  const headerProfileTitle = 'Il tuo Profilo'

  useEffect(() => {
    if (headerCtx) {
      headerCtx.updateTitles(headerTitle, headerSubTitle)
      headerCtx.updateSubtitleVariant('login_signup')
    }
  }, [])

  useEffect(() => {
    if (!headerCtx) return

    if (showSteps) {
      headerCtx.updateTitles(headerTitle, headerSubTitle)
    } else if (showRegistrationThanks) {
      headerCtx.updateTitles(headerTitle, headerRegistrationCompleteSubTitle)
    } else {
      headerCtx.updateTitles(headerProfileTitle)
    }
  }, [showSteps, showRegistrationThanks])

  return (
    <>
      {/* STEPS */}
      {showSteps ? (
        <Steps
          stepRefFoward={step2Ref}
          onStepsCompleted={() => {
            window.scrollTo(0, 0)
            setShowRegistrationThanks(true)
          }}
          onReUploadDocumentRequest={() => {
            setShowHolderDocumentModal(true)
          }}
        />
      ) : showRegistrationThanks ? (
        <RegistrationThanks
          onThanksCompleted={() => push(routes.dashboard.makeUrl())}
        />
      ) : (
        <>
          <Container>
            {/* when you need to complete the registration */}
            <CompleteRegistration
              onReUploadDocumentRequest={() => setShowHolderDocumentModal(true)}
            />
          </Container>
          <ShowData
            onReUploadDocumentRequest={() => {
              setShowHolderDocumentModal(true)
            }}
          />
        </>
      )}

      {/* MODAL */}
      {showHolderDocumentModal && (
        <Modal
          onCloseRequest={() => setShowHolderDocumentModal(false)}
          title='Aggiornamento Documento di Identità'
          size='md'
        >
          <InputHolderDocument
            isInModal
            onSuccessUpload={() => {
              setShowHolderDocumentModal(false)
            }}
          />
        </Modal>
      )}
    </>
  )
}
